import React from 'react'
import CommonSectionCategory from '../../../Shared/CommonSectionCategory';
import { categoryModel } from '../../../Model/categoryCons';

const TechGadgetsCategory = () => {
    return (
        <>
            <CommonSectionCategory props={categoryModel.TechGadgets} />
        </>
    )
}

export default TechGadgetsCategory;